import React from "react"
import { withRouter } from "react-router-dom"
import Base from "./Base"
import StepsUserFormBase from './StepsUserFormBase'
import MercadoPago from "../../Components/Payments/MercadoPago"
import { Spin, Row, Col, Card, Radio, Icon} from "antd"
import RadioButton from "antd/lib/radio/radioButton";
import { connect } from "react-redux"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
import {CopyToClipboard} from 'react-copy-to-clipboard';

class ChangePayment extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            showMercadoPago: true,
            referenceNumber: 0,
            paymentMethodId: 0
        }
    }
    // componentDidMount(){
    //     console.log("Entrando a changePayment");
    //     console.log(this.props.history.location.state.state.myPlan)
    // }

    render() {
        let nombreEntidad = this.state.paymentMethodId === 'pagofacil' ? 'Pago Fácil' : 'RapiPago'
        
        if (this.props.match.params.id === null || this.props.match.params.id === undefined){
            return (<>
            <Row></Row>
            <Row type="flex" justify="space-around" align="middle" style={{marginTop:'150px'}}>
                <Col style={{minHeight:'360px'}}>
                    <Spin indicator={CustomSpinner}/>
                </Col>
            </Row>
            <Row></Row>
            </>)
        }
        else{

            // let stepsUserCase = ((this.props.login.user_data.estado_pago ==='INACTIVO' && this.props.login.user_data.estado_monotributo ==='INACTIVO'  )|| (this.props.login.user_data.estado_pago ==='PAGO_EN_PROCESO' && this.props.login.user_data.estado_monotributo ==='INACTIVO' ))
            let stepsUserCase
            if (this.props.login.user_data){
                stepsUserCase = ((this.props.login.user_data.estado_pago ==='INACTIVO' && this.props.login.user_data.estado_monotributo ==='INACTIVO'  )|| (this.props.login.user_data.estado_pago ==='PAGO_EN_PROCESO' && this.props.login.user_data.estado_monotributo ==='INACTIVO' ))
            }else{
                stepsUserCase = false
            }
            let mercadoPagoComponent = <MercadoPago
                                            plan_id={this.props.history.location.state.state.myPlan}
                                            stepsUser={stepsUserCase}
                                            getPaymentNumber={ (refNum, entidad) => {
                                                this.setState({
                                                    showMercadoPago: false,
                                                    referenceNumber: refNum,
                                                    paymentMethodId: entidad

                                                })
                                            }}
                                        >
                                        </MercadoPago>
            
            let radioGroupComponent = <Radio.Group 
                                        onChange={(e) => this.props.history.push('/')}
                                        buttonStyle='solid'
                                        optionType='button'
                                        style={{ 
                                            width: '100%',
                                            display:'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            textAlign: 'center'
                                        }}
                                            >

                                        <Card
                                            bodyStyle={{ 
                                                padding: '0',
                                                }}
                                            >
                                            <div 
                                                style={{
                                                    borderBottom: '1px solid #e3e4e5',
                                                    padding: '15px'        
                                                }}>
                                                <h3 
                                                    style={{
                                                        color: 'rgba(0, 0, 0, 0.65)'
                                                        }}>
                                                    Acercate a tu {nombreEntidad} mas cercano y compartí el código siguiente:
                                                </h3>
                                            </div>
                                            
                                            <Card 
                                                style={{ 
                                                    border: 0,
                                                    borderRadius: 0,
                                                    borderTop: 0,
                                                    background: ''
                                                }}
                                                >
                                                <b>{this.state.referenceNumber}</b> &nbsp; &nbsp;
                                                
                                                <CopyToClipboard 
                                                    text={this.state.referenceNumber}
                                                    onCopy={() => console.log('copied')}>        
                                                    <Icon type='copy' />
                                                </CopyToClipboard>
                                                
                                            </Card>
                                        </Card>

                                        <br/>
                                        <p 
                                        style={{
                                            display: stepsUserCase ? 'inline' : 'none'
                                        }}
                                            >
                                            Mientras tanto haz click en continuar para seguir con tu inscripción
                                        </p>
                                        
                                        <center>
                                            {stepsUserCase &&
                                                <RadioButton 
                                                    value={'continuar'}
                                                    style={{
                                                        color: '#FFFFFF' ,
                                                        background: '#353FDF',
                                                        border: '1px solid #353FDF',
                                                        borderRadius: '5px' 
                                                        }}>
                                                    Continuar
                                                </RadioButton>}
                                        </center>
                                    </Radio.Group>                            

            let showMercadoPagoComponent = this.state.showMercadoPago ? mercadoPagoComponent : radioGroupComponent

            let title = this.state.showMercadoPago ? 'Pago' : "Código de pago"

            let selectedComponent = stepsUserCase ? 
                                    <StepsUserFormBase
                                        title={title}
                                        >
                                        {showMercadoPagoComponent}
                                    </StepsUserFormBase> : 
                                    <Base
                                        title={title}
                                        selected="medio-pago"
                                        >
                                        {showMercadoPagoComponent}
                                    </Base>

            return (
                selectedComponent
            )
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ChangePayment));